import React from 'react'
import { NavLink } from 'react-router-dom'
import classnames from 'classnames'
import { NavItem } from './navConfig'
import RightTooltip from '../RightTooltip'

interface NavItemComponentProps {
  item: NavItem
  collapsed?: boolean
}

export const NavItemComponent: React.FC<NavItemComponentProps> = ({ item, collapsed }) => {
  const tooltipText = item.tooltipLabel ?? (typeof item.label === 'string' ? item.label : undefined)

  const link = (
    <NavLink to={item.to} className={collapsed ? 'block w-full' : undefined}>
      {({ isActive }) => (
        <div
          className={classnames(
            // Base styles
            'no-underline font-normal whitespace-nowrap py-2.5',
            collapsed ? 'flex w-full justify-center px-0' : 'px-4',
            !isActive && 'text-slate-600 dark:text-slate-400',
            // Border and transition
            !collapsed && 'border-l-4 border-transparent transition-all duration-200 ease-in-out',
            // SVG icon styles
            '[&>svg]:inline-block [&>svg]:mb-0.5',
            !collapsed && '[&>svg]:mr-2.5',
            // Hover states
            !isActive && 'hover:text-indigo-800 dark:hover:text-indigo-400',
            // Active states for parent item
            isActive && 'bg-slate-100 dark:bg-slate-900',
            isActive && 'text-indigo-800 dark:text-indigo-400',
            isActive && !collapsed && '[&]:border-indigo-600 dark:border-indigo-400',
            // Conditional class
            { 'has-children': item.children }
          )}
        >
          {item.icon}
          {!collapsed && item.label}
        </div>
      )}
    </NavLink>
  )

  return (
    <RightTooltip content={tooltipText} enabled={collapsed === true} triggerClassName={collapsed ? 'w-full' : undefined}>
      {link}
    </RightTooltip>
  )
}
